export interface PostedDateParts {
  formattedDate: string;
  relativePart: string;
  daysAgo: number | null;
  isOlderThanFourteenDays: boolean;
}

export const getPostedDateParts = (dateString: string, now = new Date()): PostedDateParts => {
  if (!dateString) return { formattedDate: 'N/A', relativePart: '', daysAgo: null, isOlderThanFourteenDays: false };
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return { formattedDate: 'N/A', relativePart: '', daysAgo: null, isOlderThanFourteenDays: false };

  const formattedDate = date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  // To calculate the difference in days, we ignore the time part of the dates.
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfJobDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  const diffInTime = startOfToday.getTime() - startOfJobDate.getTime();
  const diffInDays = Math.round(diffInTime / (1000 * 3600 * 24));

  let relativePart: string;
  if (diffInDays < 0) {
    relativePart = '';
  } else if (diffInDays === 0) {
    relativePart = '(Today)';
  } else if (diffInDays === 1) {
    relativePart = '(1 day ago)';
  } else {
    relativePart = `(${diffInDays} days ago)`;
  }
  
  return { formattedDate, relativePart, daysAgo: diffInDays, isOlderThanFourteenDays: diffInDays > 14 };
};

export const formatRelativeDate = (dateString: string): string => {
  const { formattedDate, relativePart } = getPostedDateParts(dateString);
  return `${formattedDate} ${relativePart}`.trim();
};

export const isNewJob = (dateString: string): boolean => {
  if (!dateString) return false;
  const date = new Date(dateString);
  const now = new Date();
  
  const diffInTime = now.getTime() - date.getTime();
  const diffInDays = diffInTime / (1000 * 3600 * 24);
  
  return diffInDays <= 5;
};
